import {Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import { Observable, Subscription } from 'rxjs/Rx';
import {SessionSetting, AppHttp, Resources} from '../../../app.service';
import { Pslistener } from 'app/pf.core/listener/Pslistener';
import {KeycloakService} from '../../../keycloak.service';

declare var $: any;
declare var config: any;

@Component({
  selector: 'sa-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css'],
  providers: [AppHttp],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavigationComponent implements OnInit {

  private naviSubscription : Subscription ;

  public static menuArray: any[] = [];

  menus: any[];

  constructor(private http: AppHttp,
    private router: Router,
    private cd: ChangeDetectorRef,
    private touter: Router,
    private kc: KeycloakService
  ) {}

  ngOnInit() {

    // Change detection から切り離す
    this.cd.detach() ;
    // 言語切り替え、Navigation完了時だけ、再描画を行う
    this.naviSubscription = Observable.merge(this.router.events.filter(e=>e instanceof NavigationEnd), Pslistener.i18n.subject).subscribe(e=>{
      this.cd.detectChanges();
    });

    let user = SessionSetting.getUser();
    this.menus = [];
    this.http.post('node', '/main/menu/index', user.RoleIDs).then(o => {

      let url = location.hash.substring(1);
      let idx = url.indexOf('?');
      if (idx >= 0) { url = url.substring(0, idx); }
      if (url !== '/home') {
        let actived = o.data.filter(v => v.ACTION_PATH === url);
        if (actived.length === 0) {
          SessionSetting.setUser(null);
          if (config.devMode) {
            this.router.navigate(['login']);
          } else {
            this.kc.logout();
          }
          return;
        }
      }

      // 表示データ作成関数
      let recurseFx = ( targetArray: any[], originArray: any[], parentId: string = '$') => {
        let children = originArray.filter(v => v.PARENT_ID === parentId) ;
        children.forEach(v => {
          // 属性：　IS_OUTERURL 追加
          let tmpVal = ('' + v.ACTION_PATH).toLowerCase() ;
          if (tmpVal.indexOf('http://') === 0 || tmpVal.indexOf('https://') === 0) {
            v.IS_OUTERURL = true ;
          } else {
            v.IS_OUTERURL = false ;
          }
          // v.IS_SUB_MENU = parentId != '$';
          if ($('body').hasClass('menu-on-top') && parentId === '$') {
            v.IS_SUB_MENU = false;
          } else {
            v.IS_SUB_MENU = true;
          }
          targetArray.push(v) ;

          // 再帰で子を作成する
          v.CHILDREN = [] ;
          recurseFx(v.CHILDREN, originArray, v.MENU_ID) ;
          if (v.CHILDREN.length === 0) {
            delete v.CHILDREN ;
          }
        } ) ;
      }
      // 表示データを作成する
      recurseFx(this.menus, o.data, '$') ;

      NavigationComponent.menuArray = o.data;

      // 手動でChange Detection を実行する
      this.cd.detectChanges() ;
    });
  }
}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/navigation/navigation.component.ts